import React, { useEffect, createElement } from 'react';
import { AlertTriangle, Calendar, Phone, PlayCircle, CheckCircle2, Star, TrendingUp, ArrowRight } from 'lucide-react';
export function BookCallStrategyPage() {
  useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo(0, 0)
    // Facebook Pixel
;
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('track', 'PageView');
    window.fbq('trackCustom', 'Book-Call-Confirmation');
    // Load Vimeo player script
    const playerScript = document.createElement('script');
    playerScript.src = 'https://player.vimeo.com/api/player.js';
    playerScript.async = true;
    document.head.appendChild(playerScript);
    return () => {
      if (document.head.contains(playerScript)) {
        document.head.removeChild(playerScript);
      }
    };
  }, []);
  return <div className="min-h-screen bg-black text-white font-sans selection:bg-[#00f7fc]/20 selection:text-[#00f7fc]" data-id="element-527">
      {/* Top Warning Banner */}
      <div className="w-full bg-red-600/20 border-b border-red-500/50" data-id="element-528">
        <div className="max-w-4xl mx-auto px-4 py-3 flex items-center justify-center gap-3 text-center" data-id="element-529">
          <AlertTriangle className="w-5 h-5 text-red-500 shrink-0 animate-pulse" data-id="element-530" />
          <p className="text-sm md:text-base font-bold text-red-100" data-id="element-531">
            Paso 1 de 2 completado. Tu llamada aún NO está confirmada.
          </p>
        </div>
      </div>

      <main className="max-w-4xl mx-auto px-4 py-8 md:py-12" data-id="element-532">
        {/* SECTION 1: HEADLINE */}
        <section className="text-center space-y-6 mb-12" data-id="element-533">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-black leading-tight tracking-tight" data-id="element-534">
            <span className="text-red-500" data-id="element-535">⚠️ Importante:</span> Tu Sesión
            Estratégica con Gabriel Beltrán{' '}
            <span className="underline decoration-red-500" data-id="element-536">
              NO Está Confirmada Aún
            </span>
          </h1>
          <p className="text-base md:text-2xl text-gray-300 max-w-3xl mx-auto leading-snug md:leading-relaxed" data-id="element-537">
            Para confirmar tu llamada, completa los siguientes pasos. Te tomará
            menos de 3 minutos.
          </p>
        </section>

        {/* SECTION 2: MAIN VIDEO */}
        <section className="mb-16" data-id="element-538">
          <div className="relative max-w-3xl mx-auto" data-id="element-539">
            {/* Brand blue gradient shadow */}
            <div className="absolute -inset-1 bg-gradient-to-r from-[#00f7fc] via-[#00d7dc] to-[#00f7fc] opacity-50 blur-xl rounded-2xl" data-id="element-540"></div>

            <div className="relative bg-gray-900 border border-[#00f7fc]/50 rounded-2xl overflow-hidden shadow-2xl" data-id="element-541">
              <div style={{
              padding: '56.25% 0 0 0',
              position: 'relative'
            }} data-id="element-542">
                <iframe src="https://player.vimeo.com/video/1173647975?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="FELICIDADES POR AGENDAR" data-id="element-543"></iframe>
              </div>
            </div>
          </div>
        </section>

        {/* SECTION 3: NEXT STEPS */}
        <section className="mb-16" data-id="element-544">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-8" data-id="element-545">
            Tu Plan de Acción Inmediato{' '}
            <span className="text-[#00f7fc]" data-id="element-546">(Para Asegurar Tu Llamada)</span>:
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-547">
            {/* Step 1 */}
            <div className="bg-gray-900/60 border border-gray-800 rounded-2xl p-6 flex gap-4 items-start" data-id="element-548">
              <div className="bg-[#00f7fc]/20 p-3 rounded-xl shrink-0" data-id="element-549">
                <PlayCircle className="w-6 h-6 text-[#00f7fc]" data-id="element-550" />
              </div>
              <div data-id="element-551">
                <h3 className="text-lg font-bold text-white mb-2" data-id="element-552">
                  1. Mira el video de arriba
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-553">
                  Es el paso más importante para alinear expectativas y asegurar
                  que saques el máximo provecho de nuestra llamada.
                </p>
              </div>
            </div>

            {/* Step 2 */}
            <div className="bg-gray-900/60 border border-gray-800 rounded-2xl p-6 flex gap-4 items-start" data-id="element-554">
              <div className="bg-[#00f7fc]/20 p-3 rounded-xl shrink-0" data-id="element-555">
                <Calendar className="w-6 h-6 text-[#00f7fc]" data-id="element-556" />
              </div>
              <div data-id="element-557">
                <h3 className="text-lg font-bold text-white mb-2" data-id="element-558">
                  2. AÑADE la cita a tu calendario
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-559">
                  Busca un email nuestro con el asunto "Confirmación de tu
                  Sesión Estratégica". Ábrelo y haz clic en "Añadir al
                  Calendario". Un evento en tu calendario es un compromiso real.
                </p>
              </div>
            </div>

            {/* Step 3 */}
            <div className="bg-gray-900/60 border border-gray-800 rounded-2xl p-6 flex gap-4 items-start" data-id="element-560">
              <div className="bg-[#00f7fc]/20 p-3 rounded-xl shrink-0" data-id="element-561">
                <Phone className="w-6 h-6 text-[#00f7fc]" data-id="element-562" />
              </div>
              <div data-id="element-563">
                <h3 className="text-lg font-bold text-white mb-2" data-id="element-564">
                  3. Espera la llamada de confirmación
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-565">
                  Un miembro de nuestro equipo te contactará en las próximas 24
                  horas para confirmar algunos detalles. (Por favor, contesta,
                  es parte del proceso).
                </p>
              </div>
            </div>

            {/* Step 4 */}
            <div className="bg-gray-900/60 border border-gray-800 rounded-2xl p-6 flex gap-4 items-start" data-id="element-566">
              <div className="bg-[#00f7fc]/20 p-3 rounded-xl shrink-0" data-id="element-567">
                <CheckCircle2 className="w-6 h-6 text-[#00f7fc]" data-id="element-568" />
              </div>
              <div data-id="element-569">
                <h3 className="text-lg font-bold text-white mb-2" data-id="element-570">
                  4. Prepárate para la sesión
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-571">
                  Justo debajo, encontrarás una serie de videos cortos que
                  responden a las dudas más comunes. Verlos nos ahorrará tiempo
                  para ir directo a tu estrategia.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* SECTION 4: IDENTITY RE-ANCHORING */}
        <section className="mb-16 max-w-3xl mx-auto" data-id="element-572">
          <div className="bg-gradient-to-br from-gray-900 to-black border border-gray-800 rounded-2xl p-8 md:p-10 text-center relative overflow-hidden" data-id="element-573">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#00f7fc] to-transparent" data-id="element-574"></div>

            <h2 className="text-2xl md:text-3xl font-bold mb-6" data-id="element-575">
              Recuerda por qué agendaste esta llamada.
            </h2>

            <div className="space-y-4 text-gray-300 text-lg leading-relaxed" data-id="element-576">
              <p data-id="element-577">
                Lo hiciste porque sabes que seguir improvisando, probando
                tácticas sueltas y dependiendo de la suerte no es una estrategia
                de negocio.
              </p>
              <p data-id="element-578">
                Agendaste porque estás listo para un sistema, para la claridad y
                para los resultados que tu esfuerzo realmente merece.
              </p>
              <p className="text-white font-bold text-xl mt-6" data-id="element-579">
                La versión de ti que agendó esta llamada quiere un cambio.
                Quiere pasar al siguiente nivel.{' '}
                <span className="text-[#00f7fc]" data-id="element-580">No la dejes esperando.</span>
              </p>
            </div>
          </div>
        </section>

        {/* SECTION 5: OBJECTION HANDLING VIDEOS */}
        <section className="mb-20" data-id="element-581">
          <div className="text-center mb-10" data-id="element-582">
            <h2 className="text-3xl md:text-4xl font-black mb-4" data-id="element-583">
              ¿Tienes Dudas?{' '}
              <span className="text-[#00f7fc]" data-id="element-584">
                Las Resolvemos Antes de la Llamada:
              </span>
            </h2>
            <p className="text-gray-400 text-lg" data-id="element-585">
              Mira estos videos cortos para llegar 100% preparado.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-586">
            {/* Video 1 */}
            <div className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden flex flex-col" data-id="element-587">
              <div className="bg-gray-800 relative" data-id="element-588">
                <div style={{
                padding: '56.25% 0 0 0',
                position: 'relative'
              }} data-id="element-589">
                  <iframe src="https://player.vimeo.com/video/1173156247?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title="BREAKOUT VID 1" data-id="element-590"></iframe>
                </div>
              </div>
              <div className="p-4 flex-1" data-id="element-591">
                <p className="font-bold text-sm" data-id="element-592">
                  ¿Y si HEYLLOYD no funciona para mi nicho o tipo de negocio?
                </p>
              </div>
            </div>

            {/* Video 2 */}
            <div className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden flex flex-col" data-id="element-593">
              <div className="bg-gray-800 relative" data-id="element-594">
                <div style={{
                padding: '56.25% 0 0 0',
                position: 'relative'
              }} data-id="element-595">
                  <iframe src="https://player.vimeo.com/video/1173156261?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title="BREAKOUT VID 2" data-id="element-596"></iframe>
                </div>
              </div>
              <div className="p-4 flex-1" data-id="element-597">
                <p className="font-bold text-sm" data-id="element-598">
                  Ya he invertido en otros programas y no me funcionaron. ¿Qué
                  hace a este diferente?
                </p>
              </div>
            </div>

            {/* Video 3 */}
            <div className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden flex flex-col" data-id="element-599">
              <div className="bg-gray-800 relative" data-id="element-600">
                <div style={{
                padding: '56.25% 0 0 0',
                position: 'relative'
              }} data-id="element-601">
                  <iframe src="https://player.vimeo.com/video/1173156277?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title="BREAKOUT VIDEO 3" data-id="element-602"></iframe>
                </div>
              </div>
              <div className="p-4 flex-1" data-id="element-603">
                <p className="font-bold text-sm" data-id="element-604">
                  No tengo tiempo para implementar otro sistema complejo.
                </p>
              </div>
            </div>

            {/* Video 4 */}
            <div className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden flex flex-col" data-id="element-605">
              <div className="bg-gray-800 relative" data-id="element-606">
                <div style={{
                padding: '56.25% 0 0 0',
                position: 'relative'
              }} data-id="element-607">
                  <iframe src="https://player.vimeo.com/video/1173156217?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title="BREAKOUT VID 4" data-id="element-608"></iframe>
                </div>
              </div>
              <div className="p-4 flex-1" data-id="element-609">
                <p className="font-bold text-sm" data-id="element-610">
                  Me preocupa el costo de la inversión. ¿Cuál es el ROI real?
                </p>
              </div>
            </div>

            {/* Video 5 */}
            <div className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden flex flex-col" data-id="element-611">
              <div className="bg-gray-800 relative" data-id="element-612">
                <div style={{
                padding: '56.25% 0 0 0',
                position: 'relative'
              }} data-id="element-613">
                  <iframe src="https://player.vimeo.com/video/1173156206?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title="BREAKOUT VID 5" data-id="element-614"></iframe>
                </div>
              </div>
              <div className="p-4 flex-1" data-id="element-615">
                <p className="font-bold text-sm" data-id="element-616">
                  ¿No puedo simplemente hacer lo mismo con ChatGPT y otras
                  herramientas gratuitas?
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* SECTION 6: SOCIAL PROOF */}
        <section className="mb-20" data-id="element-617">
          <div className="text-center mb-12" data-id="element-618">
            <div className="inline-flex items-center justify-center gap-2 bg-yellow-500/10 border border-yellow-500/30 rounded-full px-6 py-2 mb-6" data-id="element-619">
              <Star className="w-5 h-5 text-yellow-500 fill-yellow-500" data-id="element-620" />
              <span className="text-yellow-500 font-bold tracking-wide uppercase text-sm" data-id="element-621">
                Casos de Éxito
              </span>
            </div>
            <h2 className="text-3xl md:text-4xl font-black mb-4" data-id="element-622">
              Resultados Reales de Emprendedores que{' '}
              <span className="text-[#00f7fc]" data-id="element-623">Dejaron de Improvisar</span>
            </h2>
          </div>

          <div className="space-y-8" data-id="element-624">
            {/* Testimonial 1 (Video style) */}
            <div className="bg-gray-900 border border-gray-800 rounded-2xl p-6 md:p-8 flex flex-col md:flex-row gap-8 items-center" data-id="element-625">
              <div className="w-full md:w-1/3 bg-gray-800 rounded-xl relative overflow-hidden shrink-0" data-id="element-626">
                <div style={{
                padding: '177.78% 0 0 0',
                position: 'relative'
              }} data-id="element-627">
                  <iframe src="https://player.vimeo.com/video/1163416902?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title="Carwin Testimonial" data-id="element-628"></iframe>
                </div>
              </div>
              <div className="w-full md:w-2/3" data-id="element-629">
                <div className="flex gap-1 mb-4" data-id="element-630">
                  {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-5 h-5 text-yellow-500 fill-yellow-500" data-id="element-631" />)}
                </div>
                <p className="text-xl md:text-2xl text-gray-300 italic leading-relaxed mb-4" data-id="element-632">
                  "Pasé de repartir pizzas a generar $100,000 en un solo día. No
                  fue un golpe de suerte, fue seguir el sistema HEYLLOYD al pie
                  de la letra, sin desviarme."
                </p>
                <p className="font-bold text-white" data-id="element-633">— Carwin M.</p>
              </div>
            </div>

            {/* Testimonial 2 (Text + Image) */}
            <div className="bg-gray-900 border border-gray-800 rounded-2xl p-6 md:p-8 flex flex-col md:flex-row-reverse gap-8 items-center" data-id="element-634">
              <div className="w-full md:w-1/3 bg-gray-800 rounded-xl relative overflow-hidden shrink-0" data-id="element-635">
                <div style={{
                padding: '177.78% 0 0 0',
                position: 'relative'
              }} data-id="element-636">
                  <iframe src="https://player.vimeo.com/video/1163771829?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%'
                }} title="David Moreno TM Academy" data-id="element-637"></iframe>
                </div>
              </div>
              <div className="w-full md:w-2/3 text-center md:text-left" data-id="element-638">
                <div className="flex gap-1 mb-4 justify-center md:justify-start" data-id="element-639">
                  {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-5 h-5 text-yellow-500 fill-yellow-500" data-id="element-640" />)}
                </div>
                <p className="text-xl md:text-2xl text-gray-300 italic leading-relaxed mb-4" data-id="element-641">
                  "Estaba estancado, sin dinero para invertir en mi propia
                  academia. Después de implementar el sistema, generamos más de
                  $3,000,000. El sistema te da la confianza para escalar porque
                  sabes que funciona."
                </p>
                <p className="font-bold text-white" data-id="element-642">— David M.</p>
              </div>
            </div>

            {/* Testimonial 3 (Screenshot) */}
            <div className="bg-gray-900 border border-gray-800 rounded-2xl p-6 md:p-8" data-id="element-643">
              <div className="flex flex-col items-center text-center" data-id="element-644">
                <div className="w-full max-w-2xl bg-gray-800 rounded-xl mb-6 overflow-hidden border border-gray-700" data-id="element-645">
                  <div style={{
                  position: 'relative'
                }} data-id="element-646">
                    <video src="https://player.vimeo.com/progressive_redirect/playback/1175309646/rendition/1080p/file.mp4%20%281080p%29.mp4?loc=external&signature=413dc55fa799003dfa8f621119e11a716380945144d6f5c88b0538d0da138778" controls playsInline preload="metadata" style={{
                    width: '100%',
                    height: 'auto',
                    display: 'block',
                    borderRadius: '0.75rem'
                  }} title="Recap Zoom Calls + Testimonios" data-id="element-647"></video>
                  </div>
                </div>
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-648">
                  Resultados de alumnos de 48/HR AI Cash Machine
                </h3>
                <p className="text-gray-400 max-w-2xl leading-relaxed" data-id="element-649">
                  "Testimonios reales de alumnos que implementaron el sistema y
                  obtuvieron resultados medibles en tiempo récord."
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* SECTION 7: FINAL CTA */}
        <section className="text-center max-w-3xl mx-auto bg-gradient-to-b from-gray-900 to-black border border-gray-800 rounded-3xl p-8 md:p-12" data-id="element-650">
          <h2 className="text-2xl md:text-4xl font-black mb-6 leading-tight" data-id="element-651">
            Tu Negocio del Futuro Depende de las Decisiones que Tomas Hoy
          </h2>

          <p className="text-gray-300 text-lg mb-8 leading-relaxed" data-id="element-652">
            Has tomado la decisión correcta al agendar esta llamada. Ahora,
            completa el proceso. Confirma tu cita en el calendario, prepárate
            para la sesión y llega listo para diseñar tu plan de escalamiento.
          </p>

          <p className="text-xl font-bold text-[#00f7fc] mb-8" data-id="element-653">
            Estamos ansiosos por mostrarte lo que es posible.
          </p>

          <p className="text-gray-400 font-medium italic" data-id="element-654">
            - Gabriel Beltrán y el Equipo de HEYLLOYD
          </p>
        </section>
      </main>

      {/* FOOTER */}
      <footer className="bg-black border-t border-gray-800 py-8 md:py-12 mt-12" data-id="element-655">
        <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-656">
          <div className="mb-6" data-id="element-657">
            <p className="text-[#00f7fc] font-bold text-lg md:text-xl mb-2" data-id="element-658">
              48HRSCASHMACHINE.COM
            </p>
          </div>

          <div className="text-gray-400 text-xs md:text-sm leading-relaxed space-y-3" data-id="element-659">
            <p data-id="element-660">
              Derechos de autor © 2025, 48 Hrs AI Cash Machine: Todos los
              derechos reservados.
            </p>
            <p className="text-gray-500" data-id="element-661">
              Soporte:{' '}
              <a href="mailto:support@truemarketer.com" className="text-[#00f7fc] hover:text-[#00d7dc] transition-colors" data-id="element-662">
                support@truemarketer.com
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>;
}